import { useState } from "react";
import { CheckedEpisodeDetail, useCardInfo, usePoints } from "app/hooks";
import RentalNote from "./RentalNote";
import { CoinAndRentalContent } from "./CoinAndRentalContent";
import { CoinAndRentalWithNewCard } from "./CoinAndRentalWithNewCard";

/**
 *
 * @param param0
 * @returns
 */
export default function CoinAndRental({
  name,
  checkedEpisodes,
  seriesId,
  seriesIndexId,
  totalPrice,
  totalBonusTicket,
  closeFunction,
  isSingle = false,
}: {
  name?: string;
  seriesId?: string;
  seriesIndexId: number | undefined;
  checkedEpisodes: CheckedEpisodeDetail[];
  /** 必要合計コイン数 */
  totalPrice: number;
  /** 必要合計チケット数 */
  totalBonusTicket: number;
  isSingle?: boolean;
  closeFunction: () => void;
}) {
  // 登録カード情報
  const { cardInfo } = useCardInfo();
  //購入できるポイント商品リスト
  const { isLoading: isLoadingPoints, results } = usePoints();
  const points = results?.points;
  const [selectedPointId, setSelectedPointId] = useState<string | number>("");
  const [isCharging, setIsCharging] = useState<boolean>(false);

  if (isLoadingPoints) {
    return <div>loading</div>;
  } else {
    return (
      <div>
        <h1 className="dialog-h">コインをチャージして読む</h1>
        {/* カード情報未登録、もしくはカード情報登録と同時に購入中（isCharging=true）の時 */}
        {isCharging && (
          <CoinAndRentalWithNewCard
            selectedPointId={selectedPointId}
            checkedEpisodes={checkedEpisodes}
            isSingle={isSingle}
            name={name || ""}
            seriesId={seriesId || null}
            seriesIndexId={seriesIndexId}
            totalPrice={totalPrice}
            totalBonusTicket={totalBonusTicket}
            points={points}
            closeFunction={closeFunction}
            setIsCharging={setIsCharging}
          />
        )}
        {/* カード情報登録済みでisCharging=falseの時 */}
        {!isCharging && (
          <CoinAndRentalContent
            cardInfo={cardInfo}
            selectedPointId={selectedPointId}
            checkedEpisodes={checkedEpisodes}
            isSingle={isSingle}
            name={name || ""}
            seriesId={seriesId || null}
            seriesIndexId={seriesIndexId}
            totalBonusTicket={totalBonusTicket}
            totalPrice={totalPrice}
            points={points}
            closeFunction={closeFunction}
            setSelectedPoint={setSelectedPointId}
            setIsCharging={setIsCharging}
          />
        )}
        <RentalNote />
      </div>
    );
  }
}
